import { usePaymnetContext } from "..";
import "./system.message.scss";

const SystemMessage = () => {
    const { state, update } = usePaymnetContext();
    const { systemMessage } = state;
    const close = () => {
        update({
            ...state,
            systemMessage: {
                ...state.systemMessage,
                show: false
            }
        })
    }

    return <div className={`system-message ${systemMessage.show ? "show" : ""} ${systemMessage.type}`}>
        <span className="close" onClick={close} />
        <div className="title">{systemMessage.title}</div>
        <div className="message">{systemMessage.message}</div>
    </div>
}

export default SystemMessage;